export enum ModalStates {
  START = 'START', // Just click on apply CTA, we ask email
  UNKNOWN = 'UNKNOWN', // Email is unknown, we ask more information
  APPLIED = 'APPLIED', // Application is done
}

export enum ApplyTypes {
  free = 'free',
  jobOffer = 'jobOffer',
}
